import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faHome,
  faLongArrowAltLeft,
  faCommentDots,
  faPlayCircle,
  faCheckSquare,
  faPencilAlt,
  faPlay,
  faArrowRight,
  faArrowLeft,
  faRedoAlt,
  faSearch,
  faQuestionCircle,
  faUpload,
  faPaperPlane,
  faTrashAlt,
  faFlag, 
  faBell, 
  faSignInAlt,
  faCheckCircle,
  faTimesCircle,
  faClock, 
  faUserCog
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faClock,
  faTimesCircle,
  faHome,
  faLongArrowAltLeft,
  faCommentDots,
  faPlayCircle,
  faCheckSquare,
  faPencilAlt,
  faPlay,
  faArrowRight,
  faArrowLeft,
  faRedoAlt,
  faSearch,
  faQuestionCircle,
  faUpload,
  faPaperPlane,
  faTrashAlt,
  faFlag, 
  faBell, 
  faSignInAlt, 
  faCheckCircle, 
  faUserCog
);
